import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateEmail, privateEmailsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getBinaryUploadModule } from '@/store/base/binary-uploads/module';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const PRIVATE_EMAIL_MODULE = 'privateemail';
const dataObjectModule = getDataObjectsModule<IPrivateEmail>(privateEmailsManager, 5);
const searchModule = getSearchModule<IPrivateEmail>(privateEmailsManager);
const binaryUploadModule = getBinaryUploadModule<IPrivateEmail>(privateEmailsManager);

const privateEmailModuleInstance = merge<unknown>(dataObjectModule, searchModule, binaryUploadModule, { actions });
store.registerModule(PRIVATE_EMAIL_MODULE, privateEmailModuleInstance);

export { PRIVATE_EMAIL_MODULE };
